export default {
  hello: "Hello",
  "app.title": "Company Transportation",
  "steps.company.verification.checking": "Verifying by",
  "steps.company.verification.fail": "Unable to proceed",
  "steps.rider.name.title": "What is your name?",
  "steps.rider.name.placeholder": "First and last name",
  "steps.rider.email.title": "What is your corporate email?",
  "steps.rider.email.placeholder": "me@mycompany.com",
  "steps.rider.code.title": "Enter your",
  "steps.rider.verification.checking.title": "Requesting access for",
  "steps.rider.verification.fail.title": "Unable to process your request",
  "steps.tripschedule.overview.fail.title":
    "Unable to retrieve Service information",
  "steps.tripschedule.overview.rider.greetings": "Hello, ",
  "steps.tripschedule.overview.trip.status": "Your trip is",
  "steps.tripschedule.overview.trip.planned": "scheduled",
  "steps.tripschedule.overview.trip.on_going": "in progress",
  "steps.tripschedule.overview.trip.ended": "completed",
  "steps.tripschedule.overview.trip.embark": "Embark",
  "steps.tripschedule.overview.trip.destination": "Destination",
  "steps.tripschedule.overview.trip.scheduled_date": "Journey on",
  "steps.tripschedule.overview.trip.solicitation_number": "Service",
  "steps.tripschedule.overview.trip.last_checked_at": "Updated at",
  "steps.tripschedule.overview.trip.see_on_map": "View on map",
  "steps.tripschedule.overview.trip.your_driver": "Your driver",
  "steps.tripschedule.onmap.navbar.status.scheduled": "Scheduled",
  "steps.tripschedule.onmap.navbar.title": "SERVICE",
  "steps.tripschedule.onmap.driver.phone": "Phone",
  "steps.tripschedule.onmap.driver.phone.copied": "Phone copied to clipboard",
  "steps.tripschedule.onmap.driver.phone.clicktocopy":
    "Click to copy phone number",
  "steps.tripschedule.onmap.navbar.status.on_going": "In progress",
  "steps.tripschedule.onmap.navbar.status.planned": "Scheduled",
  "steps.tripschedule.onmap.navbar.status.ended": "Completed",
  "steps.tripschedule.onmap.alerts.fail.refresh": "Location failed",
  "steps.tripschedule.onmap.alerts.fail.location":
    "Unable to retrieve real-time location.",
  "steps.tripschedule.onmap.alerts.fail.token":
    "Unable to retrieve real-time location (auth).",
  "buttons.start": "Start",
  "buttons.continue": "Continue",
  "buttons.tryagain": "Try again",
  "errors.InvalidQRCodeRequestException":
    "Your registration was not found. Please check your details and try again.",
  "errors.UnknownException": "Unknown error",
  "errors.ServerException": "Communication error",
  "errors.InvalidCompanyCodeException": "Company not found",
  "errors.RiderCodeAlreadyExists":
    "A rider with your details is already registered",
  "errors.InvalidRegistrationRequestException": "Your details are not valid",
  "errors.RequestAlreadyExistsException": "You already have a pending request",
  "code_type.EMPLOYEE_CODE": "employee ID",
  "code_type.USER_CODE": "user code",
  "code_type.PHONE": "phone",

  "seat.login.title": "Seat Reservation",
  "seat.login.input.company": "Company code",
  "seat.login.input.internalCode": "Rider code",
  "seat.login.button": "Login",
  "seat.login.changeLanguage": "Change language",
  "seat.login.needHelp.pre": "Need help?",
  "seat.login.needHelp.link": "Touch here for customer support.",
  "seat.login.error": "Invalid company code or rider code.",
  "seat.login.warning": "Type your data correctly.",
  "seat.profile.title": "Profile",
  "seat.profile.logout": "Logout",
  "seat.profile.language": "Language",
  "seat.profile.language.change": "(change)",
  "seat.languageSelector.title": "Language",
  "seat.languageSelector.instruction": "Select your language",
  "seat.home.error.pre": "Something wrong has happened. Try again or ",
  "seat.home.error.link": "touch here for customer support",
  "seat.home.wait": "Wait",
  "seat.home.pickup": "Pickup",
  "seat.home.departure": "Departure",
  "seat.home.dropoff": "Dropoff",
  "seat.home.nextWindowOpensAt":
    "Seat reservation for next week will start at ",
  "seat.home.close": "Close",
  "seat.home.customerSupportLink": "Cant see your routes?",
  "seat.home.reducedCapacityWarning":
    "As a health measures against COVID-19, we are operating with reduced occupancy.",
  "seat.home.search": "Search by name",
  "seat.home.filter.title": "Filter by",
  "seat.home.filter.ownership": "Ownership",
  "seat.home.filter.allRoutes": "All routes",
  "seat.home.filter.myRoutes": "My routes",
  "seat.home.filter.myRoutesDescription": "Routes you are registered in",
  "seat.home.filter.direction": "Direction",
  "seat.home.filter.roundTrip": "Round trip",
  "seat.home.filter.oneWay": "One way only",
  "seat.home.filter.returnOnly": "Return only",
  "seat.home.filter.apply": "Apply filters",
  "seat.home.filter.reset": "Reset",
  "seat.home.sort.title": "Sort by",
  "seat.home.sort.availability.title": "Seat availability",
  "seat.home.sort.availability.lowest": "Lowest availability",
  "seat.home.sort.availability.highest": "Highest availability",
  "seat.home.sort.departure.title": "Departure time",
  "seat.home.sort.departure.earliest": "Earliest",
  "seat.home.sort.departure.latest": "Latest",
  "seat.home.sort.route.title": "Route name",
  "seat.home.sort.route.a-z": "A-Z",
  "seat.home.sort.route.z-a": "Z-A",
  "seat.home.sort.apply": "Apply sort",
  "seat.home.sort.reset": "Reset",
  "seat.component.week.title": "Week",
  "seat.component.week.to": "to",
  "seat.component.listReservation.legend": "Legend:",
  "seat.component.listReservation.available": "Available",
  "seat.component.listReservation.reserved": "Reserved",
  "seat.component.listReservation.blocked": "Blocked",
  "seat.component.listReservation.empty.1": "No routes",
  "seat.component.listReservation.empty.2": "available for this date",
  "seat.component.listReservation.notReserved": "Not reserved",
  "seat.component.listReservation.availableSeats": "available seats",
  "seat.component.listReservation.noAvailableSeats": "No available seats",
  "seat.component.listReservation.reservationUntil": "Book until {0} today",
  "seat.component.listReservation.reservationUntil.past": "Closed at {0}",
  "seat.component.listReservation.reservationUntil.pastYesterday": "Closed at {0} yesterday",
  "seat.component.listReservation.reservationAvailable":
    "Available for reservation from {0} to {1}",
  "seat.component.listReservation.reservationAvailableDate":
    "Available for reservation on {0}",
  "seat.component.listReservation.reservationAvailableToday":
    "Available for reservation at {0}",
  "seat.component.modal.error.title": "There is no more seat available for",
  "seat.component.modal.error.text":
    "If you still need transport on this date, please contact the Logistics Operator that serves your region for a possible conciliation.",
  "seat.component.modal.close": "Close",
  "seat.component.modal.date.1": "at",
  "seat.component.modal.date.2": "th",
  "seat.component.modal.date": "at",
  "seat.component.modal.confirm.title": "Confirm your reservation to",
  "seat.component.modal.confirm.action": "Confirm",
  "seat.component.modal.cancel": "Cancel",
  "seat.component.modal.cancel.title": "Confirm cancellation to",
  "seat.component.modal.cancel.text": "Yes, cancel",
  "seat.component.modal.cancel.can_refound_text": "You will receive your voucher back",
  "seat.component.modal.cancel.can_refound_vouchers": "Vouchers to be returned: 1",
  "seat.component.modal.cancel.cant_refound_text": "This reservation used 1 voucher",
  "seat.component.modal.voucher.required": "This reservation requires the use of a voucher",
  "seat.component.modal.voucher.available": "Vouchers available:",
  "seat.component.modal.cancel.cant_refound_warning": "Cancellations on the day of the trip do not return the voucher",
  "seat.component.modal.cancel.cant_refound_hint": "You can cancel up to the day before to keep your balance.",
  "seat.component.modal.quit.text": "Sim, quit",
  "seat.component.modal.cancel.abort": "No, back",
  "seat.component.modal.voucher.title": "Your vouchers",
  "seat.component.modal.voucher.connector": "of",
  "seat.component.modal.voucher.text": "available",
  "seat.component.modal.voucher.observation": "Renew at the end of the month",
  "seat.component.modal.voucher.hint": "Use vouchers to reserve on other routes.",
  "seat.component.modal.voucher.description": "If you cancel the trip with prior notice, the voucher returns to your balance.",
  "seat.faq.empty.title": "No FAQ available",
  "seat.faq.empty.body": "For customer support please contact your company.",
  "seat.stops.input": "Search stop",
  "seat.stops.embark": "Your embark",
  "seat.stops.address": "Your address",
  "seat.stops.steps.stops": "Stops",
  "seat.stops.steps.confirmation": "Confirmation",
  "seat.stops.title": "Choose a stop",
  "seat.stops.confirmation.title": "Confirm your reservation",
  "seat.stops.confirmation.confirm": "Confirm reservation",
  "seat.stops.confirmation.no_vouchers": "No vouchers available",
  "seat.stops.confirmation.no_vouchers_used_init": "You have already used all",
  "seat.stops.confirmation.no_vouchers_used_final": "vouchers of this month",
  "seat.stops.modal.lastReservation.confirm": "Repeat reservation",
  "seat.stops.modal.lastReservation.cancel": "Choose another stop",
  "seat.stops.modal.lastReservation.title": "Last reservation on this route",
  "seat.stops.modal.confirm.cancel":
    "By proceeding, the reservation will not be completed",
  "seat.home.myRoutes": "See my routes only",
  "seat.vanpool.tag": "Vanpool",
  "seat.vanpool.steps.stop": "Pick-up",
  "seat.vanpool.steps.destination": "Destination",
  "seat.vanpool.title.stop": "Choose your pick-up",
  "seat.vanpool.title.destination": "Choose your destination",
  "seat.vanpool.destination": "Destination",
  "seat.vanpool.parkedVan": "Parked van",
  "seat.vanpool.boarding.me": "You",
  "seat.vanpool.boarding.license": "Has a driver's license",
  "seat.vanpool.empty.stops": "No stops available for boarding",
  "seat.vanpool.empty.destinations": "No destination available from this pick-up",
  "seat.vanpool.whatsapp": "WhatsApp group",
  "seat.vanpool.destinationStop": "Destination stop",
  "seat.vanpool.whoIsGoing": "Who is on this trip",
  "seat.vanpool.driverOk": "A licensed passenger is available to drive",
  "seat.vanpool.driverMissing": "No one with a driver's license has booked yet",
  "seat.reservation.title": "Reservation details",
  "seat.reservation.status.confirmed": "Confirmed",
  "seat.reservation.status.canceled": "Canceled",
  "seat.reservation.yourTrip": "Your trip",
  "seat.reservation.walking": "Walking to pick-up",
  "seat.reservation.arrival": "Expected arrival",
  "seat.reservation.voucherUsed": "This reservation used 1 voucher",
  "seat.reservation.cancel.until": "You can cancel until {{date}}",
  "seat.reservation.cancel.button": "Cancel reservation",
  "seat.reservation.cancel.expired": "The deadline to cancel this reservation has passed.",
  "seat.vanpool.passengerOne": "{{n}} passenger",
  "seat.vanpool.passengerMany": "{{n}} passengers",
  "dyn.trip.IN": "IN",
  "dyn.trip.OUT": "OUT",
};
